import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { containers, fontSize, lineHeight, responsiveFontSize } from 'style';
import TeaserImageComponent from './image.component';

class TitleComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { teaserTitle, translateX } = this.props;
    return <Title translateX={translateX}>{teaserTitle}</Title>;
  }
}

export const Title = styled.div`
    z-index: 1;
    margin-bottom: 0;
    // ${responsiveFontSize(19, 41)};
    // line-height: ${lineHeight(52, 41)};

    // @media (min-width: ${containers.ipad + 1}px) {
    //   white-space: pre-line;
    //   transition: all;
    //   transition-delay: 0s;
    //   transition-duration: .5s;
    //   opacity: 0;
    //   transform: translateY(10px)  translateX(${props => props.translateX / containers.outerPX * 100 || 0}vw);
    //   will-change: transform opacity;

    //   ${TeaserImageComponent}:hover &, ${TeaserImageComponent}.hover & {
    //       transition-delay: 0s;
    //       transition-duration: .5s;
    //       opacity: 1;
    //       transform: translateY(0px)  translateX(${props => props.translateX / (containers.innerPX - containers.padding * 2) * 100 || 0}vw);
    //       @media (min-width: ${containers.innerPX}px) {
    //           transform: translateY(0px)  translateX(${props => props.translateX || 0}px);
    //       }
    //   }
    // }

    // @media (min-width: ${containers.innerPX}px) {
    //     /* font-size: ${fontSize(80)}; */
    //     transform: translateY(10px)  translateX(${props => props.translateX || 0}px);
    // }
`;

export default TitleComponent;
